import { lazy } from "react";
import PermissionsBancoW from "./permissions";

const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

// Componentes
const RegistroBilleteras = lazy(() => import("./views/RegistroBilleteras"));
const BilleterasBancoW = lazy(() => import("./views/BilleterasBancoW"));
const CreacionCodigosQR = lazy(() => import("./views/CreacionCodigosQR"));


const listPermissions = Object.values(PermissionsBancoW);
export const listPermissionsBancoW = listPermissions.splice(
  listPermissions.length / 2
);


export const rutasPrivadasBilleteraBancoW = {
  link: "/billetera_banco_w",
  label: (
    <AppIcons
      Logo={"BILLETERA_W"}
      name={"Billetera W"}
    />
  ),
  component: BilleterasBancoW,
  permission: [PermissionsBancoW.billeteras_banco_w],
  // subRoutes: [rutasRecaudo, rutasRetiro],
};

export const rutaGeneracionQRBancoW = {
  link: "/generacion_qr_billetera_banco_w",
  label: (
    <AppIcons
      Logo={"BILLETERA_W_QR"}
      name={"Descargar Código QR Billetera W"}
    />
  ),
  component: CreacionCodigosQR,
  permission: [PermissionsBancoW.generacion_qr_banco_w],
  // subRoutes: [rutasRecaudo, rutasRetiro],
};

export const rutasPublicasBilleteraBancoW = {
  link: "/public/registro_billetera_banco_w",
  label: (
    <AppIcons
      Logo={"DAVIVIENDA_RETIROS_Y_DEPOSITOS"}
      name={""}
    />
  ),
  component: RegistroBilleteras,
};


